<section class="cases" id="cases" [class.contraste]="this.contrasteAtivo">
    <div class="wrapper">
        <div class="cases__inner">
            <h3 class="section-title">Conheça Nosso Trabalho</h3>
            <div class="cases__slick">
                <button class="slick-arrow slick-prev">
                    <i class="fas fa-chevron-left"></i>
                </button>
                <button class="slick-arrow slick-next">
                    <i class="fas fa-chevron-right"></i>
                </button>
                <div class="slick-content">
                    <div class="cases__slick-item" *ngFor="let case of this.cases">
                        <div class="logo-img" [style.backgroundImage]="'url('+ case.Imagem +')'"></div>
                        <div class="logo-title">
                            <h3 *ngIf="case.Empresa !== null">
                                {{ case.Empresa }}
                            </h3>
                            <p *ngIf="case.Descricao !== null">
                                {{ case.Descricao }}
                            </p>
                        </div>
                        <button class="ver-mais" (click)="verMais(case)">Ver Mais</button>
                    </div>
                </div>
                <div class="slick__footer"></div>
            </div>
        </div>
    </div>
</section>
<router-outlet></router-outlet>